import React, {Component} from 'react';
import {CUSTOMIZED_REPORT, RESPONSE} from '../../resources/constant'
import {getListCustomizedReport, getAllFilesByReportTypes} from '../../Utilities/WSUtil';
import {retentionYears, allMonths, allDays, zeroPad} from '../../Utilities/DatePicker';
import {Row,Col,Form, Modal} from 'react-bootstrap';
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn} from '../../theme/MorsTheme';

export default class SearchCustomizedReport extends Component{
    constructor(props){
        super(props);        
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        //Monina start - added
        this.updateToAllDays = this.updateToAllDays.bind(this);
        this.updateFromAllDays = this.updateFromAllDays.bind(this);
        //Monina end - added
        this.state = {        
            cu: JSON.parse(localStorage.getItem(RESPONSE)),    
            checkedAllReport:false, 
            searchSingleId: '',            
            validated: false,
            loading: false,
            folderNames:[],
            toAllDays: allDays, //Monina added
            fromAllDays: allDays, //Monina added
        };
    }          
    componentWillMount(){
        getListCustomizedReport(this.state.cu.user.userId)
        .then(response => {            
            this.setState({folderNames: response});
        })         
    }

    toggleChange = () => {        
        this.setState({
            checkedAllReport: !this.state.checkedAllReport
        });
      }

    //Monina start - added
    updateToAllDays(e){
        var toYear = document.getElementById('toYear').value;
        var toMonth = document.getElementById('toMonth').value;
        var valYear = (typeof toYear !== 'undefined') ? toYear : 0;
        var valMonth = (typeof toMonth !== 'undefined') ? toMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            toAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateFromAllDays(e){
        var fromYear = document.getElementById('fromYear').value;
        var fromMonth = document.getElementById('fromMonth').value;
        var valYear = (typeof fromYear !== 'undefined') ? fromYear : 0;
        var valMonth = (typeof fromMonth !== 'undefined') ? fromMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            fromAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateAllDays(year, month){
        var selDate = new Date(year, month, 0);
        var arrResult = [];
        Array.from(Array(selDate.getDate())).map((e,i)=>i+1).forEach(function(value, idx){
            arrResult[idx+1] = value;
        });
        return arrResult;
    }
    //Monina end - added  
    
    handleChange(e){
        this.setState(
            {                
                [e.target.id]: e.target.value   
            }
        )
    }

    isInputValid(){
        var dateFrom = new Date(document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value);

        var dateTo = new Date(document.getElementById('toMonth').value+
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value);


        var timeDiff = Math.abs(dateTo.getTime() - dateFrom.getTime());
        var dateDiff = (timeDiff / (1000 * 3600 * 24)) + 1;
        
        if(this.state.searchSingleId === '' && this.state.checkedAllReport === false){                        
            alert('Please Select Customized Report.')            
            return false;
        }

        if(!(this.state.checkedAllReport && this.state.cu.user.allReportAccess)){
            if(dateFrom > dateTo){
                alert('Date To must be greater than Date From.')            
                return false;
            }

            if(dateDiff > 31 ){
                alert('Date range should not exceed to 31 days.');            
                return false;
            }
        }
    
        return true;
    }
   
    handleSubmit(event) {
        event.preventDefault();                 
        var date_From = document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value;

        var date_To = document.getElementById('toMonth').value +
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value;
                
        if(this.isInputValid()){

            if(this.state.checkedAllReport && this.state.cu.user.allReportAccess){
                date_To = date_From;
            }

            this.setState({loading:true})
            getAllFilesByReportTypes(                      
                this.state.cu.user.userId,
                this.state.cu.user.groupId,
                "1",          
                "1",
                date_From,
                date_To,            
                CUSTOMIZED_REPORT,            
                this.state.searchSingleId,            
                this.state.checkedAllReport
            ).then(response => {                
                this.setState({loading:false});
                this.props.getTypeReport(CUSTOMIZED_REPORT); 
                //alert('Customized Report');    
                this.props.getCustomizedReportsList(response);
                //this.props.getReports(response);
                // this.props.history.push("/reportsFileList");
            }).catch(error =>{            
                this.setState({
                    loading:false                                        
                })                                             
            })    
        }    
    }

    render(){                                  
        return(                   
            <div>           
            <BodyHeaderDiv>
                   <BodyHeaderText style={{fontSize:'12px', fontWeight:'bold'}}>Search Customized Reports</BodyHeaderText>
           </BodyHeaderDiv>
           <ContentDiv>
           <Row>
               <Col md={3}></Col>                
               <Col md={6}>
               <div align="center">
                   <Col hidden={!(this.state.checkedAllReport && this.state.cu.user.allReportAccess)} >
                        <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}}>
                                Users with access to all MIDs are limited to single date search. Please select a date.
                        </span>
                    </Col>
                </div>
               <Form onSubmit={this.handleSubmit}>                          
                    <Form.Row>
                       <Form.Group as={Col} controlId="checkedAllReport" onChange={this.toggleChange}>
                           <Form.Check size='lg' label='View All Customized Reports' checked={this.state.checkedAllReport} style={{fontWeight:'bold'}}/>                                                                                                                                            
                       </Form.Group>
                   </Form.Row>   
                   <Form.Label style={{fontWeight:'bold'}}>View Specific Customized Report</Form.Label>
                   <Form.Row>
                        <Form.Group as={Col} controlId="searchSingleId" onChange={this.handleChange}>                               
                            <Form.Control as="select" size='sm' disabled={this.state.checkedAllReport}>
                            <option selected disable value={''}>Please Select</option>
                                {
                                    this.state.folderNames.map((option, index) => 
                                    <option key={index} value={option.folderName}>{option.folderName}</option> )  
                                }                              
                            </Form.Control>                                                                
                        </Form.Group>
                    </Form.Row>
                    <Form.Label size='sm' style={{fontWeight:'bold'}}>Report Date From</Form.Label>                                        
                   <Form.Row>                                                
                       <Form.Group as={Col} controlId="fromMonth" onChange={this.updateFromAllDays}>                                                            
                           <Form.Control as="select" size='sm'>
                           {   allMonths.map((option, index) =>                             
                               <option key={index} value={option.id}>{option.month}</option> )  
                           }                              
                           </Form.Control>                                                                
                       </Form.Group>
                       <Form.Group as={Col} controlId="fromDay" onChange={this.handleChange}>                                                                                            
                           <Form.Control as="select" size='sm'>
                           {   this.state.fromAllDays.map((option, index) =>                                 
                               <option key={index} value={zeroPad(option,2)}>{option}</option>)
                           }                             
                           </Form.Control>                                                                
                       </Form.Group>
                       <Form.Group as={Col} controlId="fromYear" onChange={this.updateFromAllDays}>                                                                                            
                           <Form.Control as="select" size='sm'>
                           {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                                                                              
                               <option key={index} value={option}>{option}</option>)
                           }                            
                           </Form.Control>                                                                
                       </Form.Group>                                                         
                   </Form.Row>
                   {/* <Form.Label size='sm' style={{fontWeight:'bold'}}>To</Form.Label> */}
                   {/* <Form.Row>                        */}
                   <Form.Label size='sm' style={{fontWeight:'bold'}} hidden={this.state.checkedAllReport?this.state.cu.user.allReportAccess?true:false:false} >To</Form.Label>
                   <Form.Row hidden={this.state.checkedAllReport?this.state.cu.user.allReportAccess?true:false:false}> 
                       <Form.Group as={Col} controlId="toMonth" onChange={this.updateToAllDays}>
                           <Form.Control as="select" size='sm'>
                           {   allMonths.map((option, index) =>
                               <option key={index} value={option.id}>{option.month}</option>)                          
                           } 
                           </Form.Control>                            
                       </Form.Group>
                       <Form.Group as={Col} controlId="toDay" onChange={this.handleChange}>
                           <Form.Control as="select" size='sm' >
                           {   this.state.toAllDays.map((option, index) => 
                               <option key={index} value={zeroPad(option,2)}>{option}</option>)
                           } 
                           </Form.Control>                            
                       </Form.Group>
                       <Form.Group as={Col} controlId="toYear" onChange={this.updateToAllDays}>
                           <Form.Control as="select" size='sm' >
                           {   retentionYears.sort((a,b) => b - a ).map((option, index) =>                                   
                               <option key={index} value={option}>{option}</option>)
                           } 
                           </Form.Control>                            
                       </Form.Group>
                   </Form.Row>
                   
                   <div align="center">
                    <SubmitBtn style={{color:'#FFFFFF'}}>View Report</SubmitBtn> 
                    </div>

                </Form>  
                    </Col>
                    <Col md={3}>
                    </Col>
                </Row>
            </ContentDiv>        
            <Modal show={this.state.loading} backdrop={'static'}  centered={true} backdropClassName='fade' dialogClassName="modal-bdox">  
                    <div>
                        <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader>                
                    </div>                                  
                </Modal>                                                                    
        </div>
        )
    }
}


